import classnames from 'classnames'
import PropTypes from 'prop-types'

import AddressBookIcon from '../../../../shared_components/AddressBookIcon'

import './addressBookLink.scss'

const AddressBookLink = ({className, onClick}) => (
  <a className={classnames('address-book-link', className)} onClick={onClick}>
    <div className='action-link-icon-wrapper'>
      <AddressBookIcon className='action-link-icon' />
    </div>
    <span> Address Book</span>
  </a>
)

AddressBookLink.propTypes = {onClick: PropTypes.func}

export default AddressBookLink
